@if (!isEditMode) {
	<div class="container">
		<div class="container__header">
			<div class="container__title">{{ reminderConfig.timestamp }} {{ reminderConfig.user }}</div>
			@if (reminderConfig.actions?.length) {
				<div class="container__actions">
					@for (action of reminderConfig.actions; track action) {
						<mat-icon
							[title]="action.tooltip | translate"
							[svgIcon]="action.icon"
							tabindex="0"
							class="container__icon container__icon--clickable"
							(keydown.enter)="onReminderAction(action.id)"
							(click)="onReminderAction(action.id)"
						>
						</mat-icon>
					}
				</div>
			}
		</div>
		<div class="container__content" [class.container__content--completed]="reminder.completed">
			<div class="container__content-title" [class.container__content-title--completed]="reminder.completed">
				<span>{{ 'MODALS.TASK.REMINDERS.REMINDER_TITLE' | translate }}</span>
			</div>
			<div class="container__content-header">
				<span class="container_task-name" [class.container__task-name--completed]="reminder.completed">{{
					taskData().name
				}}</span>
				<div class="container__entity">
					<mat-icon
						class="container__icon"
						[svgIcon]="taskData().entity.icon"
						[class.container__icon--completed]="reminder.completed"
					></mat-icon>
					<a
						class="container__link container__link--single"
						[class.container__link--completed]="reminder.completed"
						[attr.href]="taskData().entity.link"
						[attr.target]="taskData().entity.link ? '_blank' : null"
					>
						{{ taskData().entity.name }}
					</a>
				</div>
			</div>
			<div class="container__content-details" [class.container__content-details--completed]="reminder.completed">
				{{ reminderConfig.details || '' }}
			</div>
		</div>
	</div>
}
@if (isEditMode) {
	<task-reminder-form
		[reminder]="reminder"
		(onSubmit)="onReminderAction(reminderActionsEnum.Save, $event)"
		(onClose)="onReminderAction($event)"
	>
	</task-reminder-form>
}
